import { useId } from 'react';
import type { CustomFieldProps } from './types';
import { DateTimePicker } from '../../dynamic-field/components/date-field/date-time-picker';
import { parseDate } from '@internationalized/date';
import { CustomFieldHelperText } from './custom-field-helper-text';
import { CustomFieldLabel } from './custom-field-label';
import { DateTime } from 'luxon';

export function CustomDateField({
  title,
  onValueChange,
  value,
  disabled,
  required,
  description,
  error,
}: CustomFieldProps) {
  const id = useId();

  return (
    <div className='w-full not-first:*:mt-2'>
      <CustomFieldLabel required={required} htmlFor={id}>
        {title}
      </CustomFieldLabel>
      <DateTimePicker
        isRequired={required}
        hideResetButton={required}
        value={
          value
            ? // Have to convert the date from this: 2025/06/10 so the parseDate function can be happy. This ensures the correct timezone 🤮
              parseDate(
                DateTime.fromFormat(value, 'yyyy/MM/dd').toFormat('yyyy-MM-dd')
              )
            : null
        }
        isDisabled={disabled}
        onChange={(value) => {
          const backendParsedValue = value
            ? DateTime.fromISO(value.toString()).toFormat('yyyy/MM/dd')
            : '';
          onValueChange?.(backendParsedValue);
        }}
      />
      <CustomFieldHelperText error={error} description={description} />
    </div>
  );
}
